declare namespace $ {

	type $mol_list__rows_bog_dobro_app_charity_1 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_charity['charity_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $bog_dobro_app_charity extends $mol_page {
		charity_rows( ): readonly(any)[]
		Charity_list( ): $mol_list
		title( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_text__text_bog_dobro_app_charity_row_1 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_charity_row['title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_dobro_app_charity_row_2 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_charity_row['description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $bog_dobro_app_charity_row extends $mol_card {
		title( ): string
		Title( ): $mol_text
		description( ): string
		Description( ): $mol_text
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=charity.view.tree.d.ts.map